import LinkButton from '@app/src/components/LinkButton'
import Avatar, { AvatarSize } from '@app/src/components/Ui/Avatar'
import { providersByIdLink } from '@app/src/pages/ResourceCollection/Collections/ProvidersMrt/providerTableLink'
import { Check, CloseOutlined } from '@mui/icons-material'
import { Alert, Button, DialogContent, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { ProviderTabs } from '../../Providers/ProvidersScene'

/** Named, not just identified: the supplier table's chip labels with the name it is handed. */
type InvitedProvider = { id: number; name?: string }

type ConnectSuccessScreenProps = {
  invitedProviders: InvitedProvider[]
  missingContactProviders: InvitedProvider[]
  onClose: () => void
}

const ConnectSuccessScreen: React.FC<ConnectSuccessScreenProps> = ({
  invitedProviders = [],
  missingContactProviders = [],
  onClose,
}) => {
  const { formatMessage } = useIntl()

  return (
    <DialogContent>
      <Stack height="100%" alignItems="center">
        <Stack flexGrow={1} alignItems="center" justifyContent="center" width={488}>
          <Avatar variant="circular" size={AvatarSize.XXXL} sx={{ bgcolor: 'success.main' }}>
            <Check color="primary" sx={{ fontSize: 64 }} />
          </Avatar>
          <Typography mt={3}>
            {formatMessage(
              { id: 'form.connectProviders.success.description' },
              { invitedProvidersCount: invitedProviders.length },
            )}
          </Typography>

          <Stack spacing={2} mt={4}>
            <Button onClick={onClose} startIcon={<CloseOutlined />}>
              {formatMessage({ id: 'general.close' })}
            </Button>
            <LinkButton
              variant="outlined"
              to={providersByIdLink(ProviderTabs.NotConnected, invitedProviders)}
              onClick={onClose}
            >
              {formatMessage(
                { id: 'form.connectProviders.success.viewInvited' },
                { invitedProvidersCount: invitedProviders.length },
              )}
            </LinkButton>
            {Boolean(missingContactProviders.length) && (
              <LinkButton
                variant="contained"
                to={providersByIdLink(ProviderTabs.MissingContacts, missingContactProviders)}
                onClick={onClose}
              >
                {formatMessage(
                  { id: 'form.connectProviders.success.viewMissing' },
                  { missingContactCount: missingContactProviders.length },
                )}
              </LinkButton>
            )}
          </Stack>
        </Stack>

        <Stack width={488}>
          <Divider sx={{ my: 4 }} />
          <Alert variant="filled" severity="info" sx={{ backgroundColor: 'common.white', alignItems: 'flex-start' }}>
            {formatMessage({ id: 'form.connectProviders.success.infoAlert' })}
          </Alert>
        </Stack>
      </Stack>
    </DialogContent>
  )
}

export default ConnectSuccessScreen
